@switch (typeSelection()) {
  @case ('checkbox') {
    <!--     {{price().id}} &#45;&#45; {{price().seatIds | json }} {{onCheckout()}}<br>-->
    <div class="flex items-center justify-end py-2 lg:py-2.5 min-w-[120px] lg:min-w-[165px] gap-2.5">
      <mat-checkbox
        [checked]="onCheckout()"
        [disabled]="disabledPlusOne()"
        (change)="onCheckboxChange($event.checked)"></mat-checkbox>
    </div>
  }
  @default {
    <!--      {{ seatIds() | json }}<br>-->
    <div class="flex items-center justify-center py-2 lg:py-2.5 min-w-[120px] lg:min-w-[165px] gap-1 lg:gap-2.5">
      <button
        class="bt-qty-minus-one-temp !min-w-0 w-8 h-8 lg:w-10 lg:h-10 relative flex items-center justify-center border
          border-solid border-gray-300 text-primary bg-transparent rounded transition-colors disabled:opacity-40
          disabled:cursor-not-allowed"
        [disabled]="disabledMinusOne()"
        (click)="qtyMinusOne()">
        <mat-icon class="!m-0 !text-[20px] lg:!text-[24px]">remove</mat-icon>
      </button>

      <input
        [value]="seatIds() && seatIds().length > 0 ? getQtyForOnlySeatIdsSelected() : price?.qty || 0"
        class="w-8 lg:w-10 font-bold text-center bg-white border-none text-sm lg:text-[17px] text-black"
        disabled />

      <button
        class="bt-qty-plus-one-temp !min-w-0 w-8 h-8 lg:w-10 lg:h-10 relative flex items-center justify-center border
          border-solid border-gray-300 text-primary bg-transparent rounded transition-colors disabled:opacity-40
          disabled:cursor-not-allowed"
        [disabled]="disabledPlusOne()"
        (click)="qtyPlusOne()">
        <mat-icon class="!m-0 !text-[20px] lg:!text-[24px]">add</mat-icon>
      </button>
    </div>
  }
}
